import axios from '../utils/axios';

export default function addShowcaseV2Plan(adminId, data) {
    return axios.post('/admin/' + adminId + '/add-showcase-v2-plan', data);
}